<!--
 * @Author: jason
 * @Date: 2024-12-14 14:39:11
 * @LastEditTime: 2024-12-23 09:57:21
 * @LastEditors: jason
 * @Description:
 * @FilePath: \lonsdor-center-backend\src\App.vue
 *
-->
<template>
  <el-config-provider :locale="currentLocale">
    <router-view />
    <ReDialog />
  </el-config-provider>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { checkVersion } from "version-rocket";
import { ElConfigProvider } from "element-plus";
import { ReDialog } from "@/components/ReDialog";
import en from "element-plus/es/locale/lang/en";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { useFonticonStoreHook } from "./store/modules/fonticon";
import { useUserStoreHook } from "./store/modules/user";
import { getToken } from "./utils/auth";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "app",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    ReDialog
  },
  computed: {
    currentLocale() {
      return this.$storage.locale?.locale === "zh" ? zhCn : en;
    }
  },
  mounted() {
    let data = getToken();

    if (data) {
      useFonticonStoreHook().getIconLibrary();
      //useUserStoreHook().getDepartmentUsers();
    }
  },
  created() {},
  beforeCreate() {
    const { version, name: title } = __APP_INFO__.pkg;
    const { VITE_PUBLIC_PATH, MODE } = import.meta.env;

    // https://github.com/guMcrey/version-rocket/blob/main/README.zh-CN.md#api
    if (MODE === "production" || MODE === "test") {
      // 版本实时更新检测，只作用于线上环境
      checkVersion(
        // config
        {
          // 5分钟检测一次版本
          pollingTime: 300000,
          localPackageVersion: version,
          //originVersionFileUrl: `${location.origin}${VITE_PUBLIC_PATH}version.json`
          originVersionFileUrl: `${location.origin}/version.json`
        },
        // options
        {
          title,
          description: "检测到新版本",
          buttonText: "立即更新"
        }
      );
    }
  }
});
</script>

<style lang="scss">
.tab-wr {
  box-sizing: border-box;
  padding: 10px;

  .avue-crud {
    .avue-crud__pagination {
      padding: 10px 0;
    }
  }
}

@media (width <= 768px) {
  .tab-wr {
    width: 100vw;
    padding-top: 22px !important;
    overflow-x: auto !important;
    pointer-events: auto;
    -webkit-overflow-scrolling: touch !important;

    .avue-crud {
      .avue-crud__pagination {
        padding: 0;
      }
    }

    .avue-form {
      height: 90px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch !important;
      pointer-events: auto;
    }

    .avue-crud__header {
      width: 100vw;
      overflow-x: auto !important;
      pointer-events: auto;
      -webkit-overflow-scrolling: touch !important;
    }

    .avue-crud__right {
      display: none;
    }
  }
}
</style>
